module.exports = __webpack_public_path__ + "assets/floor-turbine.png?d3933bffdd150d377a8522d4e4f9c405";